import { InputCurrency, InputText } from "@sellar-io/components";
import { UseFormReturn } from "react-hook-form";
import { InputLabel, InputContainer } from "@sellar-io/components";
import { useRemoteFeatureFlags } from "../../../hooks/useRemoteFeatureFlags";

export type PriceTierFormValues = {
  name: string;
  minimumOrderPrice: string;
};

export const PriceTierForm = ({
  form,
  formId,
  onSave,
}: {
  form: UseFormReturn<PriceTierFormValues>;
  formId: string;
  onSave: (data: PriceTierFormValues) => void;
}) => {
  const register = form.register;

  const unbundlingRelease2aEnabled = useRemoteFeatureFlags().isActive(
    "unbundlingRelease2A",
  );

  return (
    <form
      className={"flex flex-col gap-2"}
      id={formId}
      onSubmit={form.handleSubmit(onSave)}
    >
      <div>
        <InputLabel>Name</InputLabel>
        <InputContainer>
          <InputText {...register("name", { required: true })} />
        </InputContainer>
      </div>
      {!unbundlingRelease2aEnabled && (
        <div>
          <InputLabel>Minimum order value</InputLabel>
          <InputContainer>
            <InputCurrency
              showPrefix
              allowNegative
              {...register("minimumOrderPrice", { required: false })}
            />
          </InputContainer>
        </div>
      )}
    </form>
  );
};
